// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-link[data-v-246e288c]{color:#666}.v-link--button[data-v-246e288c]{padding:12px 18px;background:#444;border:0;color:#fff;font-size:13px;border-radius:4px;cursor:pointer;text-decoration:none;box-sizing:border-box;height:44px;line-height:24px}.v-link--block[data-v-246e288c]{display:block;width:100%;text-align:center}.v-link[data-v-246e288c]:hover{opacity:.9}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
